export default __webpack_public_path__ + "static/media/member1.22ac1d59.jpg";